import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sellcast': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M353.4 32H94.7C42.6 32 0 74.6 0 126.6V385.3C0 437.4 42.6 480 94.7 480H353.4C405.5 480 448.1 437.4 448.1 385.4V126.6C448.1 74.6 405.5 32 353.4 32zM303.4 348.4C275.5 396.6 213.5 413.3 165.2 385.6 142.3 425.4 110.3 394.2 122.9 372.4L138.6 345.2C144.5 334.9 157.8 331.3 168.1 337.3 186.7 348.1 168 337.2 186.6 348 214.2 363.9 250 354.3 266 326.7 281.9 299.1 272.3 263.3 244.7 247.3 226.9 237.1 244.1 246.9 226.1 236.7 201.5 222.5 222.7 184.8 247.7 199.2 266.3 210 247.6 199.1 266.2 209.9 314.6 237.9 331.3 300.2 303.4 348.4zM325.2 139.6C308.2 169.1 308.9 168.4 306.2 171.1 299.7 177.6 289.9 179.8 279.7 174.7 261.1 163.9 279.8 174.8 261.2 164 233.6 148.1 197.8 157.7 181.8 185.3S175.5 248.7 203.1 264.7C203.1 264.7 221.6 275.3 221.7 275.3 246.3 289.5 225.1 327.2 200.1 312.8 181.5 302 200.2 312.9 181.6 302.1 133.4 274.3 116.7 212 144.5 163.7 172.4 115.5 234.4 98.8 282.7 126.5L287.5 118.1C301.8 93.2 339.5 114.8 325.2 139.6z'
      }
    ]
  }
})
